import { render, staticRenderFns } from "./StatsValidesMyAffil.vue?vue&type=template&id=ec94d86e&"
import script from "./StatsValidesMyAffil.vue?vue&type=script&lang=js&"
export * from "./StatsValidesMyAffil.vue?vue&type=script&lang=js&"
import style0 from "./StatsValidesMyAffil.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports